import { FC, JSX } from 'react';
import { Grid } from '@mui/material';
// components
import ProductIngredientForm from './Form';
// interfaces
import { ProductIngredientFormProps } from 'interfaces';

const AddProductIngredientForm: FC<ProductIngredientFormProps> = ({
  loading,
  isEdit = false,
}): JSX.Element => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={6} md={12}>
        <ProductIngredientForm loading={loading} isEdit={isEdit} />
      </Grid>
    </Grid>
  );
};

export default AddProductIngredientForm;
